import { ReactNode, useMemo } from 'react';
import { StyleSheetManager as StyledStyleSheetManager } from 'styled-components';
import stylisRTLPlugin from 'stylis-plugin-rtl';
import { useIsomorphicLayoutEffect } from 'core/common/hooks';
import { LanguageDirection } from 'core/localization/entities';
import { useLanguage } from 'core/localization/hooks';

type StyleSheetManagerProps = {
  children: ReactNode;
};

const StyleSheetManager = ({ children }: StyleSheetManagerProps) => {
  const { dir } = useLanguage();

  const stylisPlugins = useMemo(
    () => (dir === LanguageDirection.RTL ? [stylisRTLPlugin] : []),
    [dir],
  );

  useIsomorphicLayoutEffect(() => {
    document.documentElement.dir = dir;
  }, [dir]);

  return (
    <StyledStyleSheetManager stylisPlugins={stylisPlugins}>{children}</StyledStyleSheetManager>
  );
};

export default StyleSheetManager;
